import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPoint, AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { storeInterventionsAdminRouter } from './routing/storeInterventionsAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  storeInterventionsCreateNewRequestAccessControl,
  storeInterventionsViewAccessControl,
} from './access-control/storeInterventionsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'store-interventions',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'store-interventions-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    admin: [storeInterventionsAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.MarketplaceOps,
      attachToV2: AdminNavEntryPointV2.Operations,
      subNavItems: [
        {
          route: 'app-admin-store-interventions-request-list',
          labelId: 'storeInterventionsDomain.navbar.requestList.label',
          accessControl: storeInterventionsViewAccessControl,
        },
        {
          route: 'app-admin-store-interventions-create-request',
          labelId: 'storeInterventionsDomain.navbar.createRequest.label',
          accessControl: storeInterventionsCreateNewRequestAccessControl,
        },
      ],
    },
  ],
}

export default definition
